// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"e39babdf","395":"9bfc1adc"}[chunkId] + ".chunk.css";
};